export default __webpack_public_path__ + "static/media/fill-in-the-blank.3cfaa7df.svg";